import { Component, inject } from '@angular/core';
import { ToastService } from '@core/services';
import { ClaimService } from '@core/services/http/claim.service';
import { buttonConfig } from '@core/types/types';
import { bootstrapCheck, bootstrapCopy } from '@ng-icons/bootstrap-icons';
import { TranslateModule } from '@ngx-translate/core';
import { CustomButtonComponent, IconsComponent } from '@shared/components';

@Component({
  templateUrl: 'preauthorized-claim-created-modal-content.html',
  imports: [TranslateModule, IconsComponent, CustomButtonComponent],
})
export class PreauthorizedClaimCreatedModalContentComponent {
  private claimService = inject(ClaimService);
  private toastService = inject(ToastService);

  protected initialClaimInfo = this.claimService.initialClaimInfo();
  protected claimInfo = this.claimService.claim();

  protected iconCheck = bootstrapCheck;

  protected copyClaimBtn = {
    type: 'icon',
    icon: bootstrapCopy,
    color: 'info',
    theme: 'ghost',
    action: this.copyPreauthorizedClaimToClipboard.bind(this),
  } as buttonConfig;

  copyPreauthorizedClaimToClipboard() {
    navigator.clipboard.writeText(
      this.claimInfo?.preauthorization?.preauthorizedClaimNumber!
    );
    
    this.toastService.show({
      ref: 'preauthorizedClaimNumberCopied',
      delay: 3000,
      color: 'success',
      message: {
        key: 'app.pageId.claim.preauthorized-claim-copied',
      },
      icon: bootstrapCopy,
    });
  }

  message = '';

  ngOnInit() {
    this.message = `app.pageId.claim.${this.initialClaimInfo?.claimInfo.type}-preauthorization-created-message`;
  }
}
